import React from 'react';
import PropTypes from 'prop-types';

import ColumnedSection from '../right-pane/columned-section';
import DomainDetailsNotesContainer from './domain-details-notes-container';
import ExpansionComponent from '../right-pane/expansion-component';

import {
    formatCommaSeparatedList,
    formatDate,
    formatSubDomainDmarcPolicy
} from '../utils/common-utils';
import { translate } from '../utils/translation-utils';

const ClaimedDomainDetailsTabGeneral = ( { domainData, domainNotesData } ) => {
    const {
        domainType, totalMailCount,
        dmarc: { subdomainPolicy, statusPolicy },
        lastDmarcPolicyChangeDate, dateApproved, domainGroups = []
    } = domainData;

    const domainHeadings = [
        { automationId: 'cdd-domain-type', title: 'Domain Type', value: translate( domainType ) },
        { automationId: 'cdd-domain-type', title: 'Total Volume', value: totalMailCount },
        { automationId: 'cdd-dmarc-policy', title: 'DMARC Policy', value: translate( statusPolicy ) },
        { automationId: 'cdd-subdomain-policy', title: 'DMARC Subdomain Policy', value: formatSubDomainDmarcPolicy( subdomainPolicy ) },
        { automationId: 'cdd-last-change-date', title: 'Last Policy Change', value: formatDate( lastDmarcPolicyChangeDate ) },
        { automationId: 'cdd-claimed-date', title: 'Claimed Date', value: formatDate( dateApproved ) },
        { automationId: 'cdd-domain-groups', title: 'Domain Group', value: formatCommaSeparatedList( domainGroups ) },
    ];

    return (
        <>
            <ColumnedSection data={domainHeadings} labelWidthPercent={45}/>
            <ExpansionComponent title="Notes" dataAutomationId="dd-notes-section">
                <DomainDetailsNotesContainer domainNotesData={domainNotesData} />
            </ExpansionComponent>
        </>
    );
};

ClaimedDomainDetailsTabGeneral.propTypes = {
    domainData: PropTypes.shape( {
        actionsCount: PropTypes.number,
        authorizedMailVolume: PropTypes.number,
        dkimAlignRate: PropTypes.string,
        dkimPassAlignRate: PropTypes.string,
        dkimPassRate: PropTypes.string,
        dmarcDoublePassRate: PropTypes.string,
        dmarcPassRate: PropTypes.string,
        dmarcPolicy: PropTypes.string,
        domainCount: PropTypes.number,
        domainName: PropTypes.string,
        domainType: PropTypes.string,
        orgDomain: PropTypes.string,
        percentBlocked: PropTypes.string,
        spfAlignRate: PropTypes.string,
        spfPassAlignRate: PropTypes.string,
        spfPassRate: PropTypes.string,
    } ),
    domainNotesData: PropTypes.array,
};

export default ClaimedDomainDetailsTabGeneral;
